import { render, staticRenderFns } from "./InvoiceOrTaxDocument.vue?vue&type=template&id=3e0927f3&"
import script from "./InvoiceOrTaxDocument.vue?vue&type=script&lang=js&"
export * from "./InvoiceOrTaxDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports